export class ContentTags {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get content() {
        return this.parent;
    }
    /*
    get nthLocalItemOfType(): number {
      return (
        1 +
        this.content.aspect.persistentAspect.traits
          .filter(
            trait =>
              trait.key === this.content.type &&
              (trait === this.content.trait || !trait.traitGroup || trait.traitGroup !== this.content.trait.traitGroup)
          )
          .indexOf(this.content.trait)
      );
    }
  */
    get autoTags() {
        const autoTags = [];
        const nth = this.content.trait.nthLocalPosition;
        const owner = this.content.aspect.actor;
        const ownerAspectName = this.content.aspect.name;
        if (nth > 0) {
            if (this.content.trait.aspect === this.content.aspect) {
                // legacy
                autoTags.push(`${owner.type}-${this.content.type}-${nth}`);
            }
            // removed: 11.12.2020: this.content.trait.aspect === this.content.aspect &&
            autoTags.push(`${owner.type}_${ownerAspectName}-${this.content.type}-${nth}`);
            owner.autoTags.forEach(parentTag => {
                autoTags.push(`${parentTag}-${this.content.type}-${nth}`);
            });
        }
        if (this.content.trait.traitGroup) {
            autoTags.push(`${this.content.reg.unifier || this.content.trait.key}-${this.content.trait.traitGroup}-${this.nthUnifiedItemOfTraitGroup}`);
        }
        if (this.content.trait.aspect !== this.content.aspect) {
            // imported
            const tag = `${owner.type}_${ownerAspectName}-${this.content.type}-from-${this.content.trait.aspect.actor.type}-${this.content.trait.aspect.name}-${this.content.trait.nthLocalPosition}`;
            autoTags.push(tag);
        }
        return autoTags;
    }
    get nthUnifiedItemOfTraitGroup() {
        return (1 +
            this.content.aspect.persistentAspect.traits
                .filter(trait => {
                return trait.reg.unifier === this.content.reg.unifier && trait.traitGroup === this.content.trait.traitGroup;
            })
                .indexOf(this.content.trait));
    }
}
